import React, { useRef, useState, useEffect, useCallback } from "react";
import CustomDialog from "../../global/components/CustomModal/CustomModal";
import { ReactComponent as CloseIcom } from "../../assets/icons/close.svg";
import { Box, Typography } from "@mui/material";
import IdealTimeStyles from "./IdealTimeStyles";
import history from "../../utils/history";
import { useDispatch } from "react-redux";
import { logOutAction } from "../../redux/authSlice";
import urls from "../../global/constants/UrlConstants";
import CustomButton from "../../global/components/CustomButton/CustomButton";
import Timer from "./Timer";
import Stopwatch from "../../assets/icons/stopwatch.png";

interface CustomProps {
  isDialogOpen: boolean;
}

const IDLE_MS = 12 * 60 * 60 * 1000; // 12 hours

const IdealTime = (_props: CustomProps) => {
  const classes = IdealTimeStyles;
  const inactivityTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isIdle, setIsIdle] = useState(false);
  const dispatch = useDispatch();

  const clearIdleTimer = useCallback(() => {
    if (inactivityTimeout.current) {
      clearTimeout(inactivityTimeout.current);
      inactivityTimeout.current = null;
    }
  }, []);

  const resetTimer = useCallback(() => {
    clearIdleTimer();
    inactivityTimeout.current = setTimeout(() => {
      setIsIdle(true);
    }, IDLE_MS);
  }, [clearIdleTimer]);

  const handleClose = useCallback(() => {
    setIsIdle(false);
  }, []);

  const handleStayIn = useCallback(() => {
    setIsIdle(false);
    resetTimer();
  }, [resetTimer]);

  const handleLogout = useCallback(() => {
    dispatch(logOutAction());
    history.push(urls.loginViewPath);
  }, [dispatch]);

  useEffect(() => {
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("touchstart", resetTimer);
    window.addEventListener("scroll", resetTimer);
    resetTimer();

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("touchstart", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      clearIdleTimer();
    };
  }, [resetTimer, clearIdleTimer]);

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcom
          onClick={() => {
            handleClose();
          }}
        />
      </Box>
    );
  };

  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.contantWrapper}>
          <Box>
            <Typography sx={classes.heading}>Need More Time?</Typography>
          </Box>
          <Box>
            <Typography sx={classes.text}>
              It has been over 10 minutes without activity. For security reason
              and protection for you data, you session is going to expire in
            </Typography>
          </Box>
          <Box>
            <Typography sx={classes.timer}>
              <img src={Stopwatch} alt="" />
              {isIdle ? <Timer initMinute={1} initSeconds={60} /> : null}
            </Typography>
          </Box>
          <Box>
            <Typography sx={classes.text}>
              to continoue youe session, select <span>Stay Signed</span> In and
              <span>click log Off </span>
              to end you session now.
            </Typography>
          </Box>

          <Box sx={classes.buttonWrapper}>
            <CustomButton
              label="Log Off"
              buttonType="secondaryBtn"
              onClick={() => {
                handleLogout();
              }}
            />
            <CustomButton
              label="Stay Signed In"
              buttonType="primaryBtn"
              onClick={() => {
                handleStayIn();
              }}
            />
          </Box>
        </Box>
      </>
    );
  };

  return (
    <CustomDialog
      fullScreen={false}
      isDialogOpen={isIdle}
      dialogHeaderContent={dialogHeaderContent()}
      dialogTitleContent={dialogTitleContent()}
      handleDialogClose={handleClose}
    />
  );
};

export default IdealTime;
